import { Component, Inject, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateRange } from 'src/app/components/company/models/new/dateRange';

@Component({
	selector: 'bt-date-filter-list',
	standalone: true,
	imports: [MatDialogModule, MatIconModule, FormsModule, MatButtonModule, MatInputModule, CommonModule, MatNativeDateModule, MatDatepickerModule],
	templateUrl: './date-filter-list.component.html',
	styleUrl: './date-filter-list.component.scss'
})
export class DateFilterListComponent implements OnInit {
	dateRange: DateRange | undefined;

	constructor(
		public dialogRef: MatDialogRef<DateFilterListComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit(): void {
		this.dateRange = this.data.selected || new DateRange();
	}

	back(): void {
		this.dialogRef.close();
	}

	apply() {
		// il range settalo con gli orari from 00:00:00 to 23:59:59 per includere tutta la giornata
		if (this.dateRange?.from) {
			this.dateRange.from.setHours(0, 0, 0, 0);
		}
		if (this.dateRange?.to) {
			this.dateRange.to.setHours(23, 59, 59, 999);
		}
		this.dialogRef.close(this.dateRange);
	}
}
